import React from 'react';
import Header from './Header';
import './DashboardHomePage.css';

export default function ModulePlaceholderPage({ title, description }) {
  return (
    <div className="cgm-page-frame cgm-page-frame--home">
      <Header />
      <div className="cgm-home-page-content">
        <div className="dashboard-home-page">
          <div className="module-placeholder">
            <h1>{title}</h1>
            <p>{description}</p>
            <p className="module-placeholder__hint">Module en cours de préparation.</p>
          </div>
        </div>
      </div>
    </div>
  );
}
